import { NgModule } from '@angular/core';


import { SharedModule } from '@aa/selfserv/shared';
import { QnaPageComponent } from './qna-page.component';
import { QnaStartComponent } from './start/start.component';
import { QnaAdviceComponent } from './advice/advice.component';

import { QnaAdviceIndexComponent } from './index/advice-index.component';
import { QnaSnippetIndexComponent } from './index/snippet-index.component';

import { QnaQuestionsComponent } from './questions/questions.component';
import { QnaCookiesPageComponent } from './cookies/cookies.component';
import { QnaCookieBannerComponent } from './cookies/cookie-banner.component';
import { QnaContactPageComponent } from './contact/contact.component';
import { QnaPrivacyPageComponent } from './privacy/privacy.component';
import { QnaMoneyManagerPageComponent } from './tools//money-manager/money-manager.component';
import { QnaAccessibilityPageComponent } from './accessibility/accessibility.component';
import { QnaSafetyPageComponent } from './safety/safety.component';


import { BreadcrumbNavComponent } from './breadcrumb-nav.component';

import { QnaRoutingModule } from './qna_routing.module';
import { QnaLanguagesComponent } from './languages/languages.component';



@NgModule({
  declarations: [
    BreadcrumbNavComponent,
    QnaPageComponent,
    QnaStartComponent,
    QnaAdviceComponent,
    QnaQuestionsComponent,
    QnaAdviceIndexComponent,
    QnaSnippetIndexComponent,
    QnaAccessibilityPageComponent,
    QnaCookiesPageComponent, QnaContactPageComponent, QnaPrivacyPageComponent,
    QnaCookieBannerComponent,
    QnaLanguagesComponent,
    QnaMoneyManagerPageComponent, // TODO: remove
    QnaSafetyPageComponent
  ],
  imports: [
    SharedModule,
    QnaRoutingModule
  ],
  exports: [  ]
})
export class QnaPageModule {
  constructor() {

  }
}
